import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, List, OptionKey, SimpleHint, Text, useResponsive } from '@common-fe/common-fe';

import { MoneyTransferStatus } from '@/modules/investments/investments.types';

import { useInitiatedTransactionsQuery } from '../queries';

import MoneyTransfersFilters from './MoneyTransfersFilters';
import MoneyTransfersItem from './MoneyTransfersItem';

const MoneyTransfers = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [currentStatuses, setCurrentStatuses] = useState<OptionKey[]>([MoneyTransferStatus.CreatedInternal]);
  const [dateRange, setDateRange] = useState<Array<Date | null>>([]);

  const { isLoading, isEmpty, data, total } = useInitiatedTransactionsQuery({
    statuses: currentStatuses,
    startDate: dateRange[0] || null,
    endDate: dateRange[1] || null,
  });

  return (
    <Box direction="column">
      <Box direction="row" align="center" margin={{ bottom: 's' }}>
        <Text size="xxlarge" weight={700}>
          {t('Initiated Transactions')}
        </Text>
        <Box align="center" margin={{ left: 'xxs' }}>
          <SimpleHint
            content={
              <Text size="small" weight={500} textAlign="center">
                {t(
                  'Initiated transactions include transaction initiated from your HSA including buys, sells, and automatic investment activity. Once processed, details of the purchase or withdrawal will be reflected in your Investment Transaction History.'
                )}
              </Text>
            }
          >
            <SimpleHint.Icon />
          </SimpleHint>
        </Box>
      </Box>

      <Box
        data-testid="money-transfer_wrapper"
        direction="column"
        margin={{ top: 'xxs' }}
        round="moduleRound"
        pad={isMobile ? 'spacing16' : 'spacing24'}
        background="module"
      >
        <Box
          direction="row"
          align="center"
          justify="between"
          margin={{ bottom: isMobile ? 'spacing12' : 'spacing24' }}
        >
          <Text size="large" weight={700}>
            {`${t('Transactions: ')} ${total}`}
          </Text>
          <MoneyTransfersFilters
            currentStatuses={currentStatuses}
            onSetCurrentStatuses={setCurrentStatuses}
            dateRange={dateRange}
            onSetDateRange={setDateRange}
          />
        </Box>
        {!isMobile && (
          <List.Header>
            <List.Header.Item flex={30}>{t('Holding name')}</List.Header.Item>
            <List.Header.Item flex={10}>{t('Amount')}</List.Header.Item>
            <List.Header.Item flex={8}>{t('Date')}</List.Header.Item>
            <List.Header.Item alignSelf="end" flex={20}>
              {t('Status')}
            </List.Header.Item>
          </List.Header>
        )}
        {isEmpty && (
          <Box
            data-testid="testId='money-transfer_loader'"
            align="center"
            justify="center"
            pad={{ top: 'l' }}
          >
            <Text>
              {t(
                'There are no pending orders. To view your completed orders, adjust the filter settings above.'
              )}
            </Text>
          </Box>
        )}
        {isLoading && <List.Preloader testId="money-transfer_loader" count={2} />}
        {data.map((item) => (
          <MoneyTransfersItem key={item.id} {...item} />
        ))}
      </Box>
    </Box>
  );
};
export default MoneyTransfers;
